import { Icon } from '../../Elements'
import React from 'react'
const Avatar = ({ url, className }: AvatarInterface) => {
  return (
    <>
      {url ? (
        <img
          src={url}
          className={`${className ?? ''} rounded-full w-20 h-20 object-fill`}
          alt='عکس کاربر'
        />
      ) : (
        <Icon
          icon='rayteb-user-footer'
          className={`${
            className ?? ''
          } border border-disable rounded-full p-2 text-xl`}
        />
      )}
    </>
  )
}

export default React.memo(Avatar)
